import React, {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
} from "react";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";

type RecaptchaContextData = {
  verify: (action: string) => Promise<string>;
};

const RecaptchaContext = createContext<RecaptchaContextData>(
  {} as RecaptchaContextData,
);

function RecaptchaProvider({ children }: PropsWithChildren) {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
      language="pt-BR"
    >
      <RecaptchaProviderInner>{children}</RecaptchaProviderInner>
    </GoogleReCaptchaProvider>
  );
}

function RecaptchaProviderInner({ children }: PropsWithChildren) {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const verify = useCallback(
    async (action: string) => {
      if (!executeRecaptcha) {
        throw new Error("reCAPTCHA ainda não carregado");
      }

      const token = await executeRecaptcha(action);
      return token;
    },
    [executeRecaptcha],
  );

  const value = useMemo<RecaptchaContextData>(() => ({ verify }), [verify]);

  return (
    <RecaptchaContext.Provider value={value}>
      {children}
    </RecaptchaContext.Provider>
  );
}

export const useRecaptcha = () => useContext(RecaptchaContext);

export default RecaptchaProvider;
